<template>
    <div id="app">
        <template v-if="!$store.getters.authenticated && $route.path.includes('/Registrieren/')">
            <Register />
        </template>
        <template v-else-if="!$store.getters.authenticated">
            <Login/>
        </template>
        <template v-else>
            <Navbar/>
            <router-view class="mt-4 mb-4"/>
        </template>
    </div>
</template>

<script>

import Navbar from './components/Navigation/Navbar'
import Login from '@/components/Auth/Login'
import Register from '@/components/Auth/Register'

export default {
    components: {
        Login,
        Register,
        Navbar
    }
}

</script>

<style>
#app {
    position: absolute;
    width: 100vw;
    height: 100vh;
}
</style>
